























import Vue from 'vue';

export default Vue.extend({
    name: 'HelpIndex',
    created() {
        this.$store.state.routeLoaded = true;
    }
})
